import { BaseEventProps } from "@tvg/amplitude";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  UNSUB_CLICK = "UNSUBSCRIBE_BUTTON_CLICK",
  UNSUB_SUCCESS = "UNSUBSCRIBE_SUCCESSFULLY",
  UNSUB_FAIL = "UNSUBSCRIBE_FAIL",
  SUB_CLICK = "SUBSCRIBE_BUTTON_CLICK",
  SUB_SUCCESS = "SUBSCRIBE_SUCCESSFULLY",
  SUB_FAIL = "SUBSCRIBE_FAIL"
}

export interface PreferencesData {
  type:
    | MediatorEventType.UNSUB_CLICK
    | MediatorEventType.SUB_CLICK
    | MediatorEventType.SUB_FAIL;
  payload: {
    gaEventLabel: string;
  };
}
